import { restApiDP } from "@plannel/services/utils/rest-api";

const getGroupbyAlgorithm = (params) => {
    return restApiDP.get("/api/bf-review-algorithm", { params })
};

const getMetrics = (params) => {
    return restApiDP.get("/api/bf-review-metrics", { params })
};

const bfReviewService = {
    getGroupbyAlgorithm,
    getMetrics
}

export default bfReviewService;